var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Work Order Schedule"}},[_c('recurring-work-order-frequencies-form',_vm._b({attrs:{"month-options":_vm.monthOptions,"frequency-options":_vm.frequencyOptions},on:{"on-submit":_vm.update,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'recurring-work-order-frequencies-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }